import React, { useState, useRef } from 'react';
import {
  Image,
  Button,
  Link,
  Modal,
  Input,
  FormControl,
  Text,
  Heading,
  VStack,
  Pressable,
  Flex,
  HStack,
} from 'native-base';
import { useAuth, useApi } from '../../hooks';

const { REACT_APP_AUTH0_REDIRECT_URI = 'https://app.ayblehealth.com' } =
  process.env;

function HeaderNav({
  changePage = null,
  formData,
  hideBack = false,
  hideLogin = false,
  page,
  pregnancyException,
  setParentPage,
  pageLinks = [],
}) {
  const [showLogin, setShowLogin] = useState(false);
  const { isAuthenticated, signOut } = useAuth();
  const [coachLogin, setCoachLogin] = useState(false);
  const backBttn = '../chevron-left-white.png';

  const logo = './../FA__ayble_health_Logo_Isabelline_white.png';
  const logoDark = './../FA__ayble_health_Logo_Isabelline.png';
  const styles = {
    navIcon: {
      backgroundSize: 'contain',
      maxHeight: '32px',
      width: '44px',
      marginTop: '4px',
      resizeMode: 'contain',
      zIndex: 2,
    },
    logo: {
      backgroundSize: 'contain',
      maxHeight: '56px',
      resizeMode: 'contain',
    },
    backBttn: {
      width: 32,
      height: 32,
    },
  };

  const handlePageChange = () => {
    if (!!changePage) {
      changePage();
      return;
    }

    if (page === 1) {
      // skip old login and go to the home page
      setParentPage(-2);
    } else if (page === 7 && formData.noDiagnosedGiCondition) {
      setParentPage((currPage) => currPage - 2);
    } else if (
      page === 7 &&
      formData.sex === 'Male' &&
      formData.gender === 'Male'
    ) {
      pregnancyException(true);
    } else setParentPage((currPage) => currPage - 1);
  };

  const NewLoginLinkModal = () => {
    const [loginMessage, setLoginMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const loginEmailRef = useRef();
    const { api } = useApi();

    const sendNewLoginLink = async (email) => {
      // if (!/@(ayble|myagora)health\.com$/.test(email)) {
      //   setLoginMessage(`Must use valid email ending with: "@ayblehealth.com"`);
      //   return;
      // }

      setIsLoading(true);

      try {
        // TODO: Setup better random nonce/state value to confirm auth flow
        const nonce = parseInt(Math.random() * 1000 * (Math.random() * 1000));
        const url = coachLogin ? `/coach/login/${nonce}` : `/login/${nonce}`;
        const redirectUri = `${REACT_APP_AUTH0_REDIRECT_URI}${
          coachLogin ? '/hc-dashboard' : ''
        }`;

        const request = {
          route: url,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          payload: { email, redirect_uri: redirectUri },
        };

        await api(request);

        setLoginMessage(`Login link sent to: ${email}`);

        setIsLoading(false);
      } catch (err) {
        setLoginMessage(err.message || 'Failed to send login link');
        console.error('Failed Register User', err);
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <Modal
        zIndex={1000}
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        justifyContent="start"
        mt="5"
      >
        <Modal.Content maxWidth="400px" bg={'light.100'} p={4}>
          <Modal.Header bg={'transparent'}>
            <Heading textAlign={'start'} fontSize={'2xl'}>
              {coachLogin ? 'Log In as Coach' : 'Log In with email'}
            </Heading>
          </Modal.Header>
          <Modal.CloseButton />
          <Modal.Body>
            {loginMessage !== '' && <Text>{loginMessage}</Text>}
            {isLoading ? (
              <Text>Sending...</Text>
            ) : (
              <FormControl mt="3">
                <FormControl.Label>Email</FormControl.Label>
                <Input
                  ref={loginEmailRef}
                  type="email"
                  placeholder="example@ayblehealth.com"
                />
              </FormControl>
            )}
          </Modal.Body>
          <Modal.Footer borderColor={'transparent'} bg={'light.100'}>
            <VStack space={2} w={'100%'} bg={'light.100'}>
              <Button
                minHeight={'unset'}
                h={'40px'}
                disabled={isLoading}
                onPress={() => {
                  sendNewLoginLink(loginEmailRef.current.value);
                }}
              >
                Send Login Link
              </Button>
              <Button
                variant="outline"
                minHeight={'unset'}
                h={'40px'}
                onPress={() => {
                  setShowLogin(false);
                }}
              >
                Cancel
              </Button>
              <Flex
                flexDirection={'row'}
                justifyContent={'center'}
                mt={5}
                w={'100%'}
              >
                <Link
                  _text={{
                    fontSize: 'xs',
                  }}
                  onPress={() => {
                    setCoachLogin(!coachLogin);
                  }}
                >
                  {coachLogin ? 'Login as regular user' : 'Login as Coach'}
                </Link>
              </Flex>
            </VStack>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    );
  };

  const hasLinksToShow = !!pageLinks.length;
  const isDark = !hasLinksToShow;

  return (
    <Flex
      alignItems={'center'}
      backgroundColor={hasLinksToShow ? 'muted.100' : 'secondary.500'}
      flexDirection={isAuthenticated ? 'row-reverse' : 'row'}
      h={'64px'}
      justifyContent={'space-between'}
      position={'relative'}
      px={'2em'}
      py={0}
      style={{ isolation: 'isolate' }}
    >
      {isAuthenticated && (
        <Link
          _text={{
            fontSize: 'xs',
            _light: {
              color: isDark ? 'light.100' : 'secondary.600',
            },
            color: isDark ? 'light.100' : 'secondary.600',
          }}
          _hover={{
            _text: {
              _light: {
                color: isDark ? 'primary.100' : 'secondary.600',
              },
              color: isDark ? 'primary.100' : 'secondary.600',
            },
          }}
          onPress={() => signOut({ returnTo: window.location.origin })}
        >
          Logout
        </Link>
      )}

      {hasLinksToShow && (
        <HStack w={300} justifyContent={'space-between'}>
          {pageLinks.map((pageLink, i) => (
            <Link
              key={`${pageLink}-${i}`}
              _text={{
                color: 'secondary.600',
                textTransform: 'none',
                textDecoration: 'none',
                fontWeight: 'medium',
              }}
              _hover={{
                _text: {
                  textDecoration: 'underline',
                  fontWeight: 'medium',
                },
              }}
              href={pageLink.href}
            >
              {pageLink.label}
            </Link>
          ))}
        </HStack>
      )}

      <Image
        size={'md'}
        style={{
          ...styles.logo,
          ...(isDark && {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
          }),
        }}
        source={{
          uri: isDark ? logo : logoDark,
        }}
        alt="Ayble Health logo"
        onClick={() => window.open('https://ayblehealth.com', '_blank')}
      />

      {!hasLinksToShow && page !== 0 && page !== -2 && (
        <Pressable variant={'closer'} onPress={handlePageChange}>
          {!hideBack && (
            <Image
              zIndex="1"
              alt="back button"
              source={backBttn}
              style={styles.backBttn}
            />
          )}
        </Pressable>
      )}

      {!isAuthenticated && !hideLogin && (
        <Link
          zIndex={5}
          _text={{
            fontSize: 'xs',
            _light: {
              color: 'light.100',
            },
            color: 'light.100',
          }}
          _hover={{
            _text: {
              _light: {
                color: 'primary.100',
              },
              color: 'primary.100',
            },
          }}
          onPress={() => setShowLogin(true)}
        >
          Login
        </Link>
      )}
      <NewLoginLinkModal />
    </Flex>
  );
}

export default HeaderNav;
